import * as z from "zod";

const FormatEnumDtoSchema = z.enum([
    "",
    "float",
    "int",
    "integer",
    "string",
    "boolean",
    "vehicle_status",
    "identity",
    "direction",
    "unix_timestamp",
    "float_list",
    "aqua",
    "float_div_ten",
    "dosificacion_anchura",
    "signal_trap",
]);

const SeriesTypeEnumDtoSchema = z.enum([
    "spline",
    "line",
    "bar",
    "area",
    "column",
]);

const PlotBandDtoSchema = z.object({
    color: z.string().trim(),
    label: z.string().trim(),
    from: z.number().nullable(),
    to: z.number().nullable(),
});

export const SensorDtoSchema = z.object({
    id: z.int().positive(),
    code: z.string().trim().optional(),
    name: z.string().trim(),
    extended_name: z.string().trim().nullish(),
    format: FormatEnumDtoSchema.nullish(),
    allow_accumulated_values: z.boolean().nullish(),
    icon: z.string().trim().nullish(),
    symbol: z.string().trim().nullish(),
    graphable: z.boolean().nullish(),
    datable: z.boolean().nullish(),
    color: z.string().trim().nullish(),
    min_threshold: z.number().nullish(),
    max_threshold: z.number().nullish(),
    good_threshold: z.boolean().nullish(),
    show_tendency: z.boolean().nullish(),
    allow_report_tendency: z.boolean().nullish(),
    allow_report_sum: z.boolean().nullish(),
    series_type: SeriesTypeEnumDtoSchema.nullish(),
    variable_plot_bands: z.array(PlotBandDtoSchema).nullish(),
    custom_plot_bands: z.array(PlotBandDtoSchema).nullish(), //TODO: If custom_plot_bands is present, use it instead of variable_plot_bands
    measurement_unit_id: z.number().nullish(),
    effective_range: z
        .object({
            min: z.number().nullable(),
            max: z.number().nullable(),
        })
        .nullish(),
});
export type SensorDto = z.output<typeof SensorDtoSchema>;
